import { DefaultAvatar } from "../ProfileSummary/index.jsx";
import React, { useState } from "react";
export default function BuscaAluno(props) {
  let students = props.students;
  let value = props.value;
  let onChange = props.onChange;
  let placeholder = props.placeholder;
  let placeholderValue =
    undefined === placeholder ? "Buscar aluno..." : placeholder;
  const [query, setQuery] = useState("");
  const [open, setOpen] = useState(false);
  const selecionado = students.find((student) => student.id === value);
  const filtrados =
    query.length >= 1
      ? students
          .filter(
            (student) =>
              student.ativo &&
              student.nome.toLowerCase().includes(query.toLowerCase()),
          )
          .slice(0, 8)
      : [];
  return (
    <div className={"busca-wrap"}>
      <div
        style={{
          display: "flex",
          gap: 6,
        }}
      >
        <input
          className={"inp"}
          style={{
            flex: 1,
          }}
          value={selecionado && !open ? selecionado.nome : query}
          placeholder={placeholderValue}
          onFocus={() => {
            setOpen(true);
            if (selecionado) {
              setQuery("");
            }
          }}
          onBlur={() => setTimeout(() => setOpen(false), 200)}
          onChange={(event) => {
            setQuery(event.target.value);
            setOpen(true);
            onChange(0);
          }}
        />
        {value > 0 && (
          <button
            type={"button"}
            className={"btn bg bs"}
            onClick={() => {
              onChange(0);
              setQuery("");
            }}
          >
            {"X"}
          </button>
        )}
      </div>
      {open && filtrados.length > 0 && (
        <div className={"busca-lista"}>
          {filtrados.map((filtrado) => (
            <div
              className={"busca-item"}
              onMouseDown={() =>
                ((item) => {
                  onChange(item.id);
                  setQuery(item.nome);
                  setOpen(false);
                })(filtrado)
              }
              key={filtrado.id}
            >
              <div
                style={{
                  width: 26,
                  height: 26,
                  borderRadius: "50%",
                  background: filtrado.foto ? "transparent" : "#1F4754",
                  color: "#FFF",
                  display: "grid",
                  placeItems: "center",
                  fontSize: 11,
                  fontWeight: 700,
                  flexShrink: 0,
                  backgroundImage: filtrado.foto
                    ? "url(".concat(filtrado.foto, ")")
                    : "none",
                  backgroundSize: "cover",
                }}
              >
                {!filtrado.foto && DefaultAvatar()}
              </div>
              <div>
                <div
                  style={{
                    fontWeight: 600,
                  }}
                >
                  {filtrado.nome}
                </div>
                <div
                  style={{
                    fontSize: 10,
                    color: "#6B8590",
                  }}
                >
                  {filtrado.escola || ""}
                  {filtrado.ano ? " - ".concat(filtrado.ano) : ""}
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
